export enum Status {
    NoActivo = 0,
    Activo = 1,
    Baja = 2
}